module.exports = __webpack_public_path__ + "static/img/risk-icon4.aee1630a.png";